let consentKey = 'cookieConsentV2';
let gtmIteration = 0;
let gtmScriptIsLoaded = false;

window.dataLayer = window.dataLayer || [];

document.addEventListener('DOMContentLoaded', function () {
    // GTM can be loaded in NL at all times.
    if (document.documentElement.lang === 'nl') {
        loadGTMScript();
    }

    let consentDiv = document.getElementById('cookie-notice-wrapper');
    let acceptAllButton = document.getElementById('cookie-notice-accept-all-btn');
    let preferencesButton = document.getElementById('cookie-notice-settings-btn');
    let cookieSettings = document.getElementById('cookie-settings');
    let preferencesSaveButton = document.getElementById('cookie-settings-save-btn');

    let analyticsInput = document.getElementById('cookie-consent-analytics');
    let marketingInput = document.getElementById('cookie-consent-marketing');

    let consentObject = {
        analytics: false,
        marketing: false,
    }

    if (consentDiv.length === 0) {
        return;
    }

    let showConsentPopup = true;

    // Check if the cookie consent is already set in localStorage
    if (localStorage.getItem(consentKey)) {
        consentObject = localStorage.getItem(consentKey);
        consentObject = JSON.parse(consentObject);

        showConsentPopup = false;

        if (consentObject.analytics) {
            analyticsInput.checked = true;
        }

        if (consentObject.marketing) {
            marketingInput.checked = true;
        }

        window.dispatchEvent(new CustomEvent('consent-update', { detail: { consent: consentObject } }));
    }

    if (showConsentPopup) {
        // Show the consent div if consent is not given
        consentDiv.style.display = 'flex';
    }

    acceptAllButton.addEventListener('click', function () {
        consentObject.analytics = true;
        consentObject.marketing = true;

        window.dispatchEvent(new CustomEvent('consent-update', { detail: { consent: consentObject } }));

        // Hide the consent div
        consentDiv.style.display = 'none';
        // Hide settings div (might be opened at the same time)
        cookieSettings.style.display = 'none';
    });

    preferencesButton.addEventListener('click', function () {
        // Show settings sidebar
        cookieSettings.style.display = 'flex';
    });

    window.addEventListener('show-cookie-preferences', (event) => {
        // Show settings sidebar
        cookieSettings.style.display = 'flex';
    });

    preferencesSaveButton.addEventListener('click', function () {
        // Save possible partial cookie settings
        consentObject.analytics = analyticsInput.checked;
        consentObject.marketing = marketingInput.checked;

        if (marketingInput.checked) {
            consentObject.analytics = true;
        }

        window.dispatchEvent(new CustomEvent('consent-update', { detail: { consent: consentObject } }));

        // Hide the consent div
        consentDiv.style.display = 'none';
        // Hide settings div
        cookieSettings.style.display = 'none';
    });
});

window.addEventListener('consent-update', (event) => {
    const consent = event.detail.consent;

    loadGTMScript();
    updateGTMConsent(consent);

    if (typeof window.initFuty === "function") {
        window.initFuty();
    }
});

function loadGTMScript() {
    if (!gtmScriptIsLoaded) {
        (function(w,d,s,l){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://leiboom.denmulderboomteelt.com/appeltje.js'+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer');
        // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        //         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        // })(window,document,'script','dataLayer','GTM-TBB9GK5L');
    }
    gtmScriptIsLoaded = true;
}

function updateGTMConsent(consent = undefined) {
    let adsDataRedaction = true;

    const storageConsent = {
        'functionality_storage': 'granted',
        'security_storage': 'granted',
        'anonymous_statistics': document.documentElement.lang === 'nl' ? 'granted' : 'denied',
        'analytics_storage': document.documentElement.lang === 'nl' ? 'granted' : 'denied',
        'enhanced_analytics_storage': 'denied',
        'personalization_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
    };

    let savedConsent = localStorage.getItem(consentKey);

    if (savedConsent) {
        savedConsent = JSON.parse(savedConsent);
    }

    if (savedConsent && savedConsent.analytics) {
        storageConsent.analytics_storage = 'granted';
        storageConsent.enhanced_analytics_storage = 'granted';
    }

    if (savedConsent && savedConsent.marketing) {
        storageConsent.personalization_storage = 'granted';
        storageConsent.ad_storage = 'granted';
        storageConsent.ad_user_data = 'granted';
        storageConsent.ad_personalization = 'granted';
        adsDataRedaction = false;
    }

    if (consent) {
        if (!consent.analytics && document.documentElement.lang === 'nl') {
            // If a user did not accept analytics cookies, but is NL user, it still may have analytics_storage
            // enhanced_analytics_storage will be set to denied and IP-adress will be anonymized.
            storageConsent.analytics_storage = 'granted';
        } else {
            storageConsent.analytics_storage = consent.analytics ? 'granted' : 'denied';
        }

        storageConsent.enhanced_analytics_storage = consent.analytics ? 'granted' : 'denied';
        storageConsent.personalization_storage = consent.marketing ? 'granted' : 'denied';
        storageConsent.ad_storage = consent.marketing ? 'granted' : 'denied';
        storageConsent.ad_user_data = consent.marketing ? 'granted' : 'denied';
        storageConsent.ad_personalization = consent.marketing ? 'granted' : 'denied';
        adsDataRedaction = !consent.marketing;

        localStorage.setItem(consentKey, JSON.stringify(consent));
    }

    const consentObject = {
        ...storageConsent,
        'region': [document.documentElement.lang]
    };

    gtag('consent', 'update', consentObject);

    if (adsDataRedaction) {
        gtag('set', 'ads_data_redaction', true);
    }

    /* Anonymize IP */
    if (storageConsent.enhanced_analytics_storage === 'granted') {
        gtag('set', 'anonymize_ip', 'false');
    } else {
        gtag('set', 'anonymize_ip', 'true');
    }

    if (gtmIteration < 1) {
        gtag('event', 'consent_init');
    }
    gtmIteration++;
    gtag('event', 'consent_updated');
}

function gtag() {
    window.dataLayer.push(arguments);
}